export enum AcEnumDDFieldProperty {
  autoIncrement = "auto_increment",
  autoNumberLength = "auto_number_length",
  autoNumberPrefix = "auto_number_prefix",
  checkInAutoNumber = "check_in_auto_number",
  checkInModify = "check_in_modify",
  checkInSave = "check_in_save",
  defaultValue = "default_value",  
  fieldTitle = "field_title",
  foreignKey = "foreign_key",
  format = "format",
  isSelectDistinct = "is_select_distinct",
  inSearchQuery = "in_search_query",
  notNull = "not_null",
  remarks = "remarks",
  required = "required",
  primaryKey = "primary_key",
  selectOptions = "select_options",
  setNullBeforeDelete = "set_null_before_delete",
  size = "size",
  uniqueKey = "unique_key"
}
